import { createReducer, MetaReducer, on } from '@ngrx/store';
import { requestFailure } from 'sharedStores/error/error.actions';
import * as DocumentActions from './document.actions';

export const documentFeatureKey = 'document';

export interface DocumentState {
    isLoading?: boolean;
    emailAddress?: string;
}

export const initialState: DocumentState = {
    isLoading: false,
    emailAddress: null,
};

export const reducers = createReducer(
    initialState,
    on(DocumentActions.sendDisclosureDocumentRequest, (state, { emailAddress }) => {
        return {
            ...state,
            emailAddress,
            isLoading: true,
        };
    }),
    on(requestFailure, (state) => ({
        ...state,
        isLoading: false,
    })),
);
export const metaReducers: MetaReducer<DocumentState>[] = [];
